import { render, staticRenderFns } from "./Data_Table_Filtro.vue?vue&type=template&id=6f10bed0&"
import script from "./Data_Table_Filtro.vue?vue&type=script&lang=js&"
export * from "./Data_Table_Filtro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports